/**
 * Cart Event Tracking Helpers
 *
 * Type-safe tracking helpers for cart interactions.
 * Uses the core event tracking service.
 */

import { trackEvent } from './eventTracker';

/**
 * Type-safe cart event tracking helpers
 */
export const trackCartEvent = {
    /**
     * Track when an item is added to cart
     */
    itemAdded: (
        productId: string,
        productName: string,
        quantity: number,
        price: number,
        isSubscription: boolean
    ) => trackEvent('cart_item_added', {
        productId,
        productName,
        quantity,
        price,
        isSubscription,
    }),

    /**
     * Track when an item is removed from cart
     */
    itemRemoved: (
        productId: string,
        productName: string,
        quantity: number
    ) => trackEvent('cart_item_removed', {
        productId,
        productName,
        quantity,
    }),

    /**
     * Track when item quantity is changed
     */
    quantityChanged: (
        productId: string,
        oldQty: number,
        newQty: number
    ) => trackEvent('cart_item_quantity_changed', {
        productId,
        oldQty,
        newQty,
    }),

    /**
     * Track when rental dates are edited
     */
    datesChanged: (
        productId: string,
        oldStart: string,
        oldEnd: string,
        newStart: string,
        newEnd: string
    ) => trackEvent('cart_item_dates_changed', {
        productId,
        oldStart,
        oldEnd,
        newStart,
        newEnd,
    }),

    /**
     * Track when cart drawer is opened
     */
    drawerOpened: (
        itemCount: number,
        source: 'header' | 'add-to-cart'
    ) => trackEvent('cart_drawer_opened', {
        itemCount,
        source,
    }),

    /**
     * Track when cart drawer is closed
     */
    drawerClosed: (
        itemCount: number,
        dwellTimeMs: number
    ) => trackEvent('cart_drawer_closed', {
        itemCount,
        dwellTimeMs,
    }),
};
